import { inject, Injectable, Type } from '@angular/core';
import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';
import { IFpCorrelationTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-tab-connect-service';
import { FpCorrelationSpectrumMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/components/fp-correlation-spectrum-minimized/fp-correlation-spectrum-minimized.component';
import { FpCorrelationSpectrumComponent } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/components/fp-correlation-spectrum/fp-correlation-spectrum.component';
import { FpCorrelationSpectrumActionType } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/services/fp-correlation-spectrum/fp-correlation-spectrum.actions';
import { FpCorrelationSpectrumStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/services/fp-correlation-spectrum/fp-correlation-spectrum.store';
import { Observable } from 'rxjs';

@Injectable()
export class FpCorrelationSpectrumConnectService implements IFpCorrelationTabConnectService {
  protected tabStore = inject(FpCorrelationSpectrumStore);
  public currentTab = FpCorrelationTabs.CorrelationSpectrum;

  public component: Type<unknown> = FpCorrelationSpectrumComponent;
  public minimizedComponent: Type<unknown> = FpCorrelationSpectrumMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isChartFullscreen(): Observable<boolean> {
    return this.tabStore.isChartFullscreenActive$;
  }

  public isActive(tab: FpCorrelationTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: IFpCorrelationData) {
    this.tabStore.dispatch({
      type: FpCorrelationSpectrumActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: IFpCorrelationData) {
    this.tabStore.dispatch({
      type: FpCorrelationSpectrumActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
